import React from 'react'
import { Link } from 'gatsby'
const Links = ({ styleClass, children }) => {
  const activeStyle = {
    background: '#5322D0',
    color: 'white',
    fontWaight: 'bold',
  }
  return (
    <ul className={styleClass}>
      <li>
        <Link to="/" className="page-link" activeStyle={activeStyle}>
          Home
        </Link>
      </li>
      <li>
        <Link to="/posts" className="page-link" activeStyle={activeStyle}>
          Posts
        </Link>
        {children}
      </li>
      <li>
        <Link to="/newsletter" className="page-link" activeStyle={activeStyle}>
          Newsletter
        </Link>
      </li>
      <li>
        <Link to="/post" className="page-link">
          Post
        </Link>
      </li>
    </ul>
  )
}

export default Links
